export const authConfig = {
  path: {
    registerConfirm: 'register/confirm',
    passwordResetConfirm: 'password/reset'
  },
  storageKey: 'authentication',
  redirectStorageKey: 'redirect'
};
